import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        backgroundColor: "#f0e5d6",
        minHeight: "100vh",
        padding: "2rem 1rem",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card
              style={{
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                overflow: "hidden",
              }}
            >
              <Card.Header
                style={{
                  backgroundColor: "#3d2c22",
                  color: "white",
                  padding: "2rem",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Link
                  to="/"
                  style={{
                    position: "absolute",
                    left: "1rem",
                    top: "1rem",
                    color: "white",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    opacity: 0.8,
                    transition: "opacity 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  ← Back to Home
                </Link>
                <h1
                  style={{
                    margin: "0 0 0.5rem 0",
                    fontSize: "2rem",
                    fontWeight: "bold",
                  }}
                >
                  Terms and Conditions
                </h1>
                <p style={{ margin: 0, opacity: 0.75, fontSize: "1rem" }}>
                  The Endless Moment Pte Ltd
                </p>
              </Card.Header>

              <Card.Body
                style={{
                  padding: "2.5rem",
                  color: "#3d2c22",
                  lineHeight: "1.7",
                }}
              >
                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    1. Introduction
                  </h3>
                  <p>
                    These Terms and Conditions ("Terms") govern the use of the
                    digital guest book services provided by The Endless Moment
                    Pte Ltd ("we", "our", "us"). By accessing or using our
                    website and services (collectively, the "Service"), you
                    agree to be bound by these Terms. Please read them
                    carefully.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    2. Definitions
                  </h3>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>User:</strong> Any individual or entity that
                      accesses or uses the Service.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Content:</strong> Any text, images, videos, or
                      other materials submitted, uploaded, or shared by a User
                      through the Service.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Account:</strong> A registered user profile
                      created with The Endless Moment for the purpose of
                      accessing the Service.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    3. Acceptance of Terms
                  </h3>
                  <p>
                    By accessing or using the Service, you confirm your
                    agreement to comply with these Terms. If you do not agree,
                    you must refrain from using the Service.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    4. Registration and Accounts
                  </h3>
                  <p>
                    To access certain features of the Service, you may be
                    required to create an Account. You agree to:
                  </p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Provide accurate, complete, and current information during
                      registration.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Maintain and promptly update such information.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Safeguard your Account credentials and accept full
                      responsibility for all activities conducted under your
                      Account.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    5. Use of the Service
                  </h3>
                  <p>
                    <strong>Eligibility:</strong> The Service is available only
                    to individuals who are at least eighteen (18) years of age.
                  </p>
                  <p>
                    <strong>Prohibited Activities:</strong> Users shall not use
                    the Service in any unlawful manner, or in a way that may
                    damage, disable, overburden, or impair the Service, its
                    servers, or connected networks.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    6. Prohibited Use
                  </h3>
                  <p>You agree not to use the Service to:</p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Violate Laws:</strong> Engage in conduct that
                      contravenes any applicable law or regulation.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Infringe Rights:</strong> Breach or infringe the
                      intellectual property or other proprietary rights of third
                      parties.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Cause Harm:</strong> Harass, defame, abuse,
                      threaten, or otherwise cause harm to others.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Impersonate:</strong> Misrepresent your identity
                      or affiliation with any person or entity.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Disrupt Service:</strong> Introduce viruses,
                      malware, or harmful code intended to disrupt or damage
                      systems.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Commit Fraud:</strong> Engage in fraudulent,
                      deceptive, or misleading practices.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Automate Access:</strong> Deploy automated systems
                      (e.g., bots, scrapers) without our express written
                      consent.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Send Spam:</strong> Disseminate unsolicited
                      advertisements, promotional materials, or spam.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    7. User Content
                  </h3>
                  <p>
                    <strong>Ownership:</strong> Users retain ownership of all
                    Content submitted via the Service.
                  </p>
                  <p>
                    <strong>Licence:</strong> By submitting Content, you grant
                    us a worldwide, non-exclusive, royalty-free, transferable
                    licence to use, reproduce, modify, and display such Content
                    in connection with the Service.
                  </p>
                  <p>
                    <strong>Responsibility:</strong> You are solely responsible
                    for the Content you submit and for compliance with all
                    applicable laws. We do not endorse or assume liability for
                    any User Content.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    8. Intellectual Property
                  </h3>
                  <p>
                    <strong>Service Content:</strong> All design, functionality,
                    features, and materials forming part of the Service are
                    protected by intellectual property laws and remain the
                    exclusive property of The Endless Moment or its licensors.
                  </p>
                  <p>
                    <strong>User Licence:</strong> We grant you a limited,
                    non-exclusive, non-transferable, revocable licence to use
                    the Service for personal, non-commercial purposes only.
                    Reproduction, distribution, modification, or derivative
                    works require our prior written consent.
                  </p>
                  <p>
                    <strong>Feedback:</strong> Any feedback or suggestions
                    provided by Users are voluntary and may be used by us
                    without obligation or compensation.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    9. Copyright
                  </h3>
                  <p>
                    <strong>Ownership:</strong> All materials and content within
                    the Service (including but not limited to text, graphics,
                    images, logos, and software) are protected by copyright and
                    related intellectual property laws.
                  </p>
                  <p>
                    <strong>Restrictions:</strong> Users may not copy,
                    reproduce, distribute, transmit, display, perform, or create
                    derivative works from such copyrighted material without
                    prior written permission.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    10. Intellectual Property Infringement
                  </h3>
                  <p>
                    <strong>Notification:</strong> If you believe that any
                    material within the Service infringes your intellectual
                    property rights, you must notify us with:
                  </p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Identification of the copyrighted work or other rights
                      allegedly infringed.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Location of the infringing material within the Service.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Your full contact details (name, address, phone, and
                      email).
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      A statement of good faith belief that the disputed use is
                      unauthorized.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      A declaration, under penalty of perjury, that the
                      information is accurate and that you are authorized to act
                      on behalf of the rights owner.
                    </li>
                  </ul>

                  <p>
                    <strong>Counter-Notification:</strong> If you believe that
                    your material was wrongfully removed, you may submit a
                    counter-notification including:
                  </p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Your contact details (name, address, phone, and email).
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      A description of the removed material and its prior
                      location.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      A statement, under penalty of perjury, that the removal
                      was due to error or misidentification.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      A declaration of consent to the jurisdiction of the courts
                      of Singapore and agreement to accept service from the
                      party who filed the original claim.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    11. Privacy
                  </h3>
                  <p>
                    Your use of the Service is subject to our Privacy Policy,
                    which governs the collection, use, and disclosure of your
                    personal information. By using the Service, you consent to
                    the practices described therein.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    12. Fees and Payments
                  </h3>
                  <p>
                    Certain features of the Service may be subject to fees,
                    payable in Singapore Dollars (SGD). All fees are
                    non-refundable. We reserve the right to revise pricing at
                    any time, provided that such changes will not affect
                    payments already made.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    13. No Order Cancellation
                  </h3>
                  <p>
                    All orders are final. Once an order is placed, it cannot be
                    cancelled, modified, or refunded. Users are responsible for
                    verifying all details prior to submission.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    14. Right to Refuse or Cancel Orders
                  </h3>
                  <p>
                    We reserve the right to refuse or cancel any order if we
                    suspect fraud, unauthorized use, or illegal activity. This
                    includes instances of identity theft, payment fraud, or
                    orders that appear to contravene these Terms or applicable
                    law.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    15. Links to Third-Party Sites
                  </h3>
                  <p>
                    The Service may contain links to third-party websites. These
                    are provided solely for convenience and informational
                    purposes. We do not control, endorse, or assume liability
                    for third-party sites or their content. Accessing such sites
                    is at your own risk.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    16. Termination
                  </h3>
                  <p>
                    We may suspend or terminate your Account or access to the
                    Service at our discretion, including for breach of these
                    Terms. You may terminate your Account at any time by
                    contacting us.
                  </p>
                  <p>
                    <strong>Data Deletion upon Termination:</strong> Upon expiry
                    or termination of your subscription, all data associated
                    with your Account—including photographs, images, and other
                    uploaded content—will be permanently deleted from our
                    systems. We do not retain data after subscription
                    termination.
                  </p>
                  <p>
                    <strong>User Responsibility:</strong> You are solely
                    responsible for backing up any Content you wish to retain
                    prior to termination. We accept no liability for any loss of
                    data after subscription expiry or termination.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    17. Disclaimers and Limitation of Liability
                  </h3>
                  <p>
                    <strong>Disclaimer:</strong> The Service is provided "as is"
                    and "as available," without warranties of any kind, whether
                    express or implied. We make no representations regarding
                    error-free operation, uninterrupted access, or the absence
                    of harmful components.
                  </p>
                  <p>
                    <strong>Limitation of Liability:</strong> To the maximum
                    extent permitted by law, we shall not be liable for
                    indirect, incidental, consequential, special, or punitive
                    damages arising out of or related to your use of the
                    Service. Our aggregate liability shall not exceed the total
                    amount paid by you for the Service in the six (6) months
                    preceding the claim.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    18. Indemnification
                  </h3>
                  <p>
                    You agree to indemnify, defend, and hold harmless The
                    Endless Moment, its affiliates, officers, directors,
                    employees, and agents from any claims, damages, liabilities,
                    losses, and expenses (including legal fees) arising from:
                  </p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Your use of the Service;
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>Your Content; or</li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Your breach of these Terms.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    19. Governing Law
                  </h3>
                  <p>
                    These Terms shall be governed by and construed in accordance
                    with the laws of Singapore. Any dispute shall be subject to
                    the exclusive jurisdiction of the courts of Singapore.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    20. Changes to Terms
                  </h3>
                  <p>
                    We reserve the right to amend these Terms at any time.
                    Changes will be effective upon posting on our website.
                    Continued use of the Service following such changes
                    constitutes acceptance of the revised Terms.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    21. Contact Us
                  </h3>
                  <p>For enquiries relating to these Terms, please contact:</p>
                  <div
                    style={{
                      backgroundColor: "#f0e5d6",
                      border: "1px solid #917054",
                      borderRadius: "8px",
                      padding: "1rem",
                      marginTop: "1rem",
                    }}
                  >
                    <p style={{ margin: "0 0 0.5rem 0", fontWeight: "bold" }}>
                      The Endless Moment Pte Ltd
                    </p>
                    <p style={{ margin: "0 0 0.25rem 0" }}>
                      🌐{" "}
                      <a
                        href="https://theendlessmoment.com/#contactus"
                        style={{ color: "#3d2c22", textDecoration: "none" }}
                      >
                        https://theendlessmoment.com/#contactus
                      </a>
                    </p>
                    <p style={{ margin: 0 }}>
                      📧{" "}
                      <a
                        href="mailto:enquiries@theendlessmoment.com"
                        style={{ color: "#3d2c22", textDecoration: "none" }}
                      >
                        enquiries@theendlessmoment.com
                      </a>
                    </p>
                  </div>
                </section>

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "2rem",
                    paddingTop: "1.5rem",
                    borderTop: "1px solid #917054",
                    color: "##666",
                    fontSize: "0.9rem",
                  }}
                >
                  <p style={{ margin: 0 }}>
                    Last updated: Please check our website for the most current
                    version of these terms.
                  </p>
                </div>
              </Card.Body>

              <Card.Footer style={{ textAlign: "center", padding: "1.5rem" }}>
                <Button
                  variant="outline-primary"
                  onClick={handleBackToHome}
                  style={{
                    backgroundColor: "#f0e5d6",
                    borderColor: "#917054",
                    color: "#3d2c22",
                  }}
                >
                  Back to Home
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
